<template>
  <div
    class="row g-3"
    :class="{ 'justify-content-center': !hasDgpoBlock }"
  >
    <div
      v-if="ogpoRows.length"
      class="col-12"
      :class="hasDgpoBlock ? 'col-md-6' : 'col-md-8 col-lg-6'"
    >
      <section>
        <h6 class="text-gray-800 fw-bold mb-3">ОГПО ВТС</h6>
        <div class="rounded border bg-light p-3 p-md-4">
          <div
            v-for="row in ogpoRows"
            :key="'ogpo-' + row.key"
            class="d-flex justify-content-between align-items-center py-2"
            :class="{ 'border-top': row.divider, 'pt-3': row.highlight, 'mt-1': row.highlight }"
          >
            <span class="fs-7" :class="row.highlight ? 'text-gray-800 fw-bold' : 'text-gray-600'">{{ row.label }}</span>
            <span :class="rowValueClass(row)">
              {{ formatMoney(row.value) }}
              <span v-if="row.showCurrency" class="fw-normal fs-8 text-gray-600">тг.</span>
            </span>
          </div>
        </div>
      </section>
    </div>

    <div
      v-if="dgpoRows.length"
      class="col-12 col-md-6"
    >
      <section>
        <h6 class="text-gray-800 fw-bold mb-3">ДГПО ВТС</h6>
        <div class="rounded border bg-light p-3 p-md-4">
          <div
            v-for="row in dgpoRows"
            :key="'dgpo-' + row.key"
            class="d-flex justify-content-between align-items-center py-2"
            :class="{ 'border-top': row.divider, 'pt-3': row.highlight, 'mt-1': row.highlight }"
          >
            <span class="fs-7" :class="row.highlight ? 'text-gray-800 fw-bold' : 'text-gray-600'">{{ row.label }}</span>
            <span :class="rowValueClass(row)">
              {{ formatMoney(row.value) }}
              <span v-if="row.showCurrency" class="fw-normal fs-8 text-gray-600">тг.</span>
            </span>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PremiumCalculationBpmDetails',
  props: {
    calculation: {
      type: Object,
      default: null,
    },
    policy: {
      type: Object,
      required: true,
    },
    module: {
      type: Function,
      required: true,
    },
  },
  computed: {
    ogpoRows() {
      return this.module.PremiumCalculation.getOgpoRows(this.calculation, this.policy)
    },
    dgpoRows() {
      return this.module.PremiumCalculation.getDgpoRows(this.calculation, this.policy)
    },
    hasDgpoBlock() {
      return this.dgpoRows.length > 0
    },
  },
  methods: {
    formatMoney(value) {
      return this.module.PremiumCalculation.formatMoney(value)
    },
    rowValueClass(row) {
      return {
        'fw-semibold': true,
        'text-gray-800': !row.color,
        'fw-bold': row.highlight,
        'fs-6': row.highlight,
        [`text-${row.color}`]: Boolean(row.color),
      }
    },
  },
}
</script>
